// extracted by mini-css-extract-plugin
export default {"container":"Booking_container__6I-Vf","card":"Booking_card__sy501","cardHeader":"Booking_cardHeader__jnGc6","cardBody":"Booking_cardBody__Mj7Sl"};